export default {
  1: '0px 4px 16px rgba(37, 45, 45, 0.05)',
  2: '0px 4px 24px rgba(37, 45, 45, 0.05)',
  3: '0px 8px 32px rgba(37, 45, 45, 0.10)',
  reversed: '0px -4px 24px rgba(37, 45, 45, 0.05)',
};
